/*! Shubert Ads Manager — install-snippet generator (single source of truth
 *  with shared/src/install_snippets.rs, which MUST produce byte-identical
 *  output; the goldens in shared/testdata/install_snippets/ are the lock).
 *
 *  ES5 + UMD on purpose: the pixel-worker /install page embeds this file
 *  verbatim inside a <script> tag (no module system), the frontend imports it
 *  for its side effect and reads window.SamInstallSnippets, and vitest loads
 *  it in Node where module.exports exists.
 *
 *  API: render(method, opts) -> string
 *    method: 'gtm' | 'head' | 'manual'
 *    opts: {
 *      host:    'pixel.shubertads.com',
 *      pixelId: 'summer25',
 *      event:   'Purchase' | 'Pageview'   (manual method only),
 *      enabled: { key: bool }             (missing key -> spec.default_on),
 *      catalog: ParamSpec[]               (shared::install_catalog order)
 *    }
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  var g = typeof root !== "undefined" && root ? root : (typeof globalThis !== "undefined" ? globalThis : {});
  g.SamInstallSnippets = api;
})(typeof self !== "undefined" ? self : this, function () {
  "use strict";

  function isOn(opts, spec) {
    if (spec.key === "pixel_id") return true; // never removable
    var e = opts.enabled || {};
    if (Object.prototype.hasOwnProperty.call(e, spec.key)) return !!e[spec.key];
    return !!spec.default_on;
  }

  function byKey(catalog, key) {
    for (var i = 0; i < catalog.length; i++) if (catalog[i].key === key) return catalog[i];
    return null;
  }

  // Align trailing comments across a block: pad each commented line's code to
  // (max code length among commented lines) + 3 spaces before the marker.
  function alignBlock(lines, marker) {
    var pad = 0;
    var i;
    for (i = 0; i < lines.length; i++) {
      if (lines[i].comment && lines[i].code.length > pad) pad = lines[i].code.length;
    }
    var out = [];
    for (i = 0; i < lines.length; i++) {
      if (lines[i].comment) {
        var gap = pad - lines[i].code.length + 3;
        var sp = "";
        for (var j = 0; j < gap; j++) sp += " ";
        out.push(lines[i].code + sp + marker + " " + lines[i].comment);
      } else {
        out.push(lines[i].code);
      }
    }
    return out;
  }

  function samValue(spec) {
    return spec.value_kind === "number" ? spec.example : "'" + spec.example + "'";
  }

  // The `sam('track', …, { … })` field lines for one event, as {code, comment}
  // pairs with `prefix` prepended (e.g. "  //   " for commented blocks).
  function trackFieldLines(opts, event, prefix) {
    var lines = [];
    var fields = [];
    for (var i = 0; i < opts.catalog.length; i++) {
      var p = opts.catalog[i];
      if (!p.sam_key || !isOn(opts, p)) continue;
      if (p.events.indexOf(event) < 0) continue;
      fields.push(p);
    }
    for (var k = 0; k < fields.length; k++) {
      var comma = k < fields.length - 1 ? "," : "";
      lines.push({
        code: prefix + fields[k].sam_key + ": " + samValue(fields[k]) + comma,
        comment: fields[k].snippet_comment || "",
      });
    }
    return lines;
  }

  function renderGtm(opts) {
    var out = [];
    out.push("<!-- Shubert Ads universal pixel — GTM Custom HTML tag.");
    out.push("     Everything below is ON by default: delete any setAttribute line you don't");
    out.push("     plan to supply. Replace EXAMPLE values with your own. -->");
    out.push("<script>");

    var loader = [];
    loader.push({ code: "  var el = document.createElement('script');", comment: "" });
    loader.push({ code: "  el.setAttribute('src', 'https://" + opts.host + "/v1/t.js');", comment: "" });
    loader.push({ code: "  el.setAttribute('data-pixel-id', '" + opts.pixelId + "');", comment: "" });
    for (var i = 0; i < opts.catalog.length; i++) {
      var p = opts.catalog[i];
      if (p.key === "pixel_id" || !p.data_attr || !isOn(opts, p)) continue;
      loader.push({
        code: "  el.setAttribute('" + p.data_attr + "', '" + p.example + "');",
        comment: p.snippet_comment || "",
      });
    }
    loader.push({
      code: "  el.setAttribute('defer', '');",
      comment: "no-op for injected scripts (already async); kept for clarity",
    });
    loader.push({ code: "  document.body.appendChild(el);", comment: "" });
    out = out.concat(alignBlock(loader, "//"));

    var track = byKey(opts.catalog, "explicit_track");
    if (track && isOn(opts, track)) {
      out.push("");
      out.push("  // OPTIONAL — explicit purchase call. Usually unnecessary: the tag auto-detects");
      out.push("  // GTM purchases (dataLayer event === \"purchase\") and your extraction rules —");
      out.push("  // configured server-side in Pixel Studio, not in this snippet — read GTM's own");
      out.push("  // dataLayer paths (ecommerce.value, ecommerce.transaction_id, ecommerce.currency).");
      out.push("  // window.sam = window.sam || function () { (window.sam.q = window.sam.q || []).push(arguments); };");
      out.push("  // window.sam('track', 'Purchase', {");
      out = out.concat(alignBlock(trackFieldLines(opts, "Purchase", "  //   "), "//"));
      out.push("  // });");
    }

    var consent = byKey(opts.catalog, "consent_hook");
    if (consent && isOn(opts, consent)) {
      out.push("");
      out.push("  // OPTIONAL — consent kill switch: set BEFORE the tag loads to suppress all tracking.");
      out.push("  // window.__samConsent = false;");
    }

    out.push("</" + "script>");
    return out.join("\n") + "\n";
  }

  function renderHead(opts) {
    var out = [];
    var consent = byKey(opts.catalog, "consent_hook");
    if (consent && isOn(opts, consent)) {
      out.push("<!-- Optional consent kill switch — must run before the tag: -->");
      out.push("<!-- <script>window.__samConsent = false;</" + "script> -->");
    }
    var attrs = [];
    for (var i = 0; i < opts.catalog.length; i++) {
      var p = opts.catalog[i];
      if (p.key === "pixel_id" || !p.data_attr || !isOn(opts, p)) continue;
      attrs.push(p.data_attr + "=\"" + p.example + "\"");
    }
    var open = "<script async src=\"https://" + opts.host + "/v1/t.js\"";
    var pid = "data-pixel-id=\"" + opts.pixelId + "\"";
    if (attrs.length === 0) {
      out.push(open + " " + pid + "></" + "script>");
    } else {
      out.push(open);
      out.push("        " + pid);
      for (var k = 0; k < attrs.length; k++) {
        var tail = k === attrs.length - 1 ? "></" + "script>" : "";
        out.push("        " + attrs[k] + tail);
      }
    }
    return out.join("\n") + "\n";
  }

  function renderManual(opts) {
    var event = opts.event === "Pageview" ? "Pageview" : "Purchase";
    var out = [];
    out.push("<script>");
    out.push("  // Load once per page (safe to re-run: guarded against double-insert).");
    out.push("  (function () {");
    out.push("    if (document.getElementById('sam-tag')) return;");
    out.push("    var el = document.createElement('script');");
    out.push("    el.id = 'sam-tag';");
    out.push("    el.setAttribute('src', 'https://" + opts.host + "/v1/t.js');");
    out.push("    el.setAttribute('data-pixel-id', '" + opts.pixelId + "');");
    out.push("    document.body.appendChild(el);");
    out.push("  })();");
    out.push("");
    out.push("  // Command queue stub — safe to call before the tag has loaded.");
    out.push("  window.sam = window.sam || function () { (window.sam.q = window.sam.q || []).push(arguments); };");

    var consent = byKey(opts.catalog, "consent_hook");
    if (consent && isOn(opts, consent)) {
      out.push("");
      out.push("  // Optional consent kill switch (set before tracking calls):");
      out.push("  // window.__samConsent = false;");
    }

    out.push("");
    out.push(event === "Purchase"
      ? "  // Fire when the purchase completes:"
      : "  // Fire on every route change (SPA pageview):");
    var fields = trackFieldLines(opts, event, "    ");
    if (fields.length === 0) {
      out.push("  window.sam('track', '" + event + "');");
    } else {
      out.push("  window.sam('track', '" + event + "', {");
      out = out.concat(alignBlock(fields, "//"));
      out.push("  });");
    }
    out.push("</" + "script>");
    return out.join("\n") + "\n";
  }

  function render(method, opts) {
    if (method === "gtm") return renderGtm(opts);
    if (method === "head") return renderHead(opts);
    if (method === "manual") return renderManual(opts);
    throw new Error("unknown snippet method: " + method);
  }

  return { render: render };
});
